import { render } from "./ImagemAbertaLandingPage.vue?vue&type=template&id=69a8b5ae&scoped=true"
import script from "./ImagemAbertaLandingPage.vue?vue&type=script&lang=js"
export * from "./ImagemAbertaLandingPage.vue?vue&type=script&lang=js"

import "./ImagemAbertaLandingPage.vue?vue&type=style&index=0&id=69a8b5ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a8b5ae"]])

export default __exports__